"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _get = _interopRequireDefault(require("lodash/get"));

var _selectors = require("./selectors");

var _actions = require("./actions");

// Return the data the reducer should use to store from action payload.
// To support the entities redux-module we must store the `entities` value
// if present instead of the `data` value.
var getDataFromPayload = function (payload) {
  var data = (0, _get.default)(payload, 'data');
  return (0, _get.default)(payload, 'entities', data);
}; // eslint-disable-next-line complexity


var updateOrDeleteReducer = function (state, _ref) {
  var type = _ref.type,
      payload = _ref.payload,
      meta = _ref.meta;
  var data = getDataFromPayload(payload);
  var resource = (0, _get.default)(meta, 'resource');
  var needle = (0, _get.default)(meta, 'request.needle');
  var needleIsObject = typeof needle === 'object';
  var list = (0, _selectors.getList)(state, resource);
  var index = needleIsObject ? (0, _findIndex.default)(list, needle) : list.indexOf(needle);

  if (index < 0) {
    return state;
  } // console.warn(state, {type, payload, meta})


  switch (type) {
    case _actions.RESOURCE_UPDATE_SUCCESS:
      return (0, _extends2.default)({}, state, {
        [resource]: (0, _extends2.default)({}, (0, _selectors.getResourceState)(state, resource), {
          list: [...list.slice(0, index), needleIsObject ? (0, _extends2.default)({}, list[index], data) : data, ...list.slice(index + 1)]
        })
      });

    case _actions.RESOURCE_DELETE_SUCCESS:
      return (0, _extends2.default)({}, state, {
        [resource]: (0, _extends2.default)({}, (0, _selectors.getResourceState)(state, resource), {
          list: [...list.slice(0, index), ...list.slice(index + 1)]
        }) // istanbul ignore next

      });

    default:
      return state;
  }
}; // eslint-disable-next-line complexity


var _default = function _default(state, _ref2) {
  if (state === void 0) {
    state = _selectors.initialState;
  }

  var type = _ref2.type,
      payload = _ref2.payload,
      meta = _ref2.meta;
  var resource = (0, _get.default)(meta, 'resource');
  if (!resource) return state;
  var data = getDataFromPayload(payload);

  switch (type) {
    case _actions.RESOURCE_CREATE_SUCCESS:
      {
        return (0, _extends2.default)({}, state, {
          [resource]: (0, _extends2.default)({}, (0, _selectors.getResourceState)(state, resource), {
            list: [data, ...(0, _selectors.getList)(state, resource)]
          })
        });
      }

    case _actions.RESOURCE_LIST_CREATE_REQUEST:
      return (0, _extends2.default)({}, state, {
        [resource]: (0, _extends2.default)({}, (0, _selectors.getResourceState)(state, resource), {
          list: (0, _selectors.getList)(_selectors.initialState, resource)
        })
      });

    case _actions.RESOURCE_LIST_CREATE_SUCCESS:
      return (0, _extends2.default)({}, state, {
        [resource]: (0, _extends2.default)({}, (0, _selectors.getResourceState)(state, resource), {
          list: data
        })
      });

    case _actions.RESOURCE_LIST_READ_REQUEST:
      return (0, _extends2.default)({}, state, {
        [resource]: (0, _extends2.default)({}, (0, _selectors.getResourceState)(state, resource), {
          list: (0, _selectors.getList)(_selectors.initialState, resource)
        })
      });

    case _actions.RESOURCE_LIST_READ_SUCCESS:
      return (0, _extends2.default)({}, state, {
        [resource]: (0, _extends2.default)({}, (0, _selectors.getResourceState)(state, resource), {
          list: data
        })
      });

    case _actions.RESOURCE_DETAIL_READ_REQUEST:
      return (0, _extends2.default)({}, state, {
        [resource]: (0, _extends2.default)({}, (0, _selectors.getResourceState)(state, resource), {
          detail: (0, _selectors.getDetail)(_selectors.initialState, resource)
        })
      });

    case _actions.RESOURCE_DETAIL_READ_SUCCESS:
      return (0, _extends2.default)({}, state, {
        [resource]: (0, _extends2.default)({}, (0, _selectors.getResourceState)(state, resource), {
          detail: data
        })
      });

    case _actions.RESOURCE_UPDATE_SUCCESS:
    case _actions.RESOURCE_DELETE_SUCCESS:
      return updateOrDeleteReducer(state, {
        type,
        payload,
        meta
      });

    default:
      return state;
  }
};

exports.default = _default;